import { useCallback, useState } from 'react'

import { useAuth } from '@/auth/useAuth'
import { IUploaderForm, TPlatformValue } from '@/types/uploadForm.interface'

import { isSourceRequired } from '../utils'

type TPlatformCompletionStatus = Partial<Record<TPlatformValue, boolean>>

interface UploaderRoles {
	isInt: boolean
	isMain: boolean
}

const getDefaultCompletionStatus = (): TPlatformCompletionStatus => ({})

const checkFormCompletion = (
	formData: IUploaderForm,
	roles: UploaderRoles
): boolean => {
	const isSourceValid =
		!isSourceRequired({ rights: formData.rights, ...roles }) ||
		Boolean(formData.source?.trim())

	return Boolean(
		formData.title &&
			formData.title.trim() !== '' &&
			formData.description &&
			formData.description.trim() !== '' &&
			formData.location &&
			formData.location.trim() !== '' &&
			formData.categories &&
			formData.categories.length > 0 &&
			formData.region !== null &&
			(formData.region ? formData.country !== null : true) && // Country required only if region is selected
			formData.rights &&
			formData.rights.trim() !== '' &&
			formData.UAERegulatedContent &&
			formData.UAERegulatedContent.trim() !== '' &&
			isSourceValid
	)
}

export const useFormCompletion = () => {
	const [platformCompletionStatus, setPlatformCompletionStatus] =
		useState<TPlatformCompletionStatus>(getDefaultCompletionStatus)

	const { isInt, isMain } = useAuth()

	const updatePlatformCompletion = useCallback(
		(platform: TPlatformValue, formData: IUploaderForm) => {
			const isCompleted = checkFormCompletion(formData, {
				isInt: Boolean(isInt),
				isMain: Boolean(isMain)
			})
			setPlatformCompletionStatus(prev => ({
				...prev,
				[platform]: isCompleted
			}))
		},
		[isInt, isMain]
	)

	return {
		platformCompletionStatus,
		updatePlatformCompletion,
		checkFormCompletion
	}
}
